module.exports = __webpack_public_path__ + "img/Ks.cd1bd9ef.png";